import Vue from "vue";
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";
import FieryVue from "fiery-vue";

Vue.use(FieryVue);

const firebaseConfig = {
  apiKey: "AIzaSyCMKU097u1d_UDqz4RNnXlQyvrol7GeRLI",
  authDomain: "sponsors-portal-docsoc.firebaseapp.com",
  databaseURL: "https://sponsors-portal-docsoc.firebaseio.com",
  projectId: "sponsors-portal-docsoc",
  storageBucket: "sponsors-portal-docsoc.appspot.com",
  messagingSenderId: "611914156004",
  appId: "1:611914156004:web:bb0a7b2fc2f27642"
};

const app = firebase.initializeApp(firebaseConfig);
export const db = firebase.firestore(app);
export const auth = firebase.auth(app);
export const storage = firebase.storage().ref();
